<template>
    <div style="position: relative; max-width: 500px;" id="divcropper1">
        <h6 class="title-cropper">{{title}}</h6>
        <div v-if="!srcImage" class="div-father-btn-toggle-camera">
            <div class="div-btn-toggle-camera">                            
                <i class="material-icons icon-button-cropper" @click.prevent="toggleOptions()">camera_alt</i>            
            </div>
            <div v-if="toggle" class="mf__div-btn-flex-space-between" style="margin-top: 20px;">
                <button class="mf__btn--confirmar" v-if="nameNavigator === 'Windows OS'" @click.prevent="loadCamera">Foto</button>

                <label v-else :for="`capture-upload-${title}`" style="margin-top: 15px 0px;" class="custom-btn-upload">Tirar Foto</label>
                <input style="display: none;" @change="setImage" :id="`capture-upload-${title}`" type="file" accept="image/*" capture="camera">

                <label :for="`file-upload-${title}`" class="custom-btn-upload">Upload de Imagem</label>
                <input style="display: none;" @change="setImage" :id="`file-upload-${title}`" type="file" accept="image/*">
            </div>
            <div id="div_area" class="area" style="display: none;">
                <video autoplay="true" id="webCamera">
                </video>
                <br>
                <br>
                <button class="custom-btn-upload"   type="button" @click.prevent="takeSnapShot">Tirar foto</button>            
            </div>
        </div>
        <div v-else class="img-document" id="divcropper2">
            <div v-if="loading">
                <div class="base_spinner" style="display: flex; position: relative;">
                    <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
            <div v-else id="divcropper3">
                <div v-if="redondlyMode" id="divcropper4">
                    <Cropper id="cropper1"
                        ref="cropper"
                        v-if="!cropedImage"
                        :src="srcImage"
                    />
                </div>
                <div v-else-if="!redondlyMode" id="divcropper5">
                    <Cropper id="cropper2"
                        ref="cropper"
                        v-if="!cropedImage"
                        :src="srcImage"
                    />
                </div>
                <br>
                <div v-if="!cropedImage" class="mf__div-btn-flex-space-between" style="margin-top: 20px 0px;">
                    <button @click.prevent="cancelImage" class="mf__btn--cancelar">Cancelar</button>
                    <button @click.prevent="cropAndUploadImage" class="mf__btn--confirmar">Ok</button>
                </div>
                <div v-else-if="cropedImage" class="uploadedImage" id="divcropper6">
                    <img :src="cropedImage">
                    <button class="mf__btn--confirmar" @click.prevent="changeImg">Escolher outra imagem</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FirebaseHelper from '@/service/FirebaseHelper';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
    components: {
        Cropper
    },
    props: {
        title: {
            type: String
        },
        filename: {
            type: String,
            required: true
        },
        redondlyMode: {
            type: Boolean,
            default: false,
        },
        picture: {
            type: String,
        }
    },
    computed: {
    ...mapGetters({
      chave: "chave"
    }),
  },
	data() {
		return {
            firebaseHelper: new FirebaseHelper(),
            srcImage: null,
            cropedImage: null,
            toggle: false,
            loading: false,
            nameNavigator: '',
            video: null
		};
	},
    created() {
        this.navigator()
        //set image if have
        if(this.picture){
            this.cropedImage = this.picture
            this.srcImage = this.picture
        }        
    },
	methods: {    
        closeVideo () {
            if (this.video) {
                var mediaStream = this.video.srcObject
                var tracks = mediaStream.getTracks()
                tracks[0].stop()
            }
        },
        dataURItoBlob (dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }            
            return new Blob([ia], {type:mimeString})
        },    
        takeSnapShot () {            
            this.video = document.querySelector("#webCamera")
            //Criando um canvas que vai guardar a imagem temporariamente
            var canvas = document.createElement('canvas')
            canvas.width = this.video.videoWidth
            canvas.height = this.video.videoHeight
            var ctx = canvas.getContext('2d')            
            //Desenhando e convertendo as dimensões
            ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height)            
            //Criando o JPG
            //O resultado é um BASE64 de uma imagem.
            var dataURI = canvas.toDataURL('image/jpeg')
            //Transformar Base em file
            var file = this.dataURItoBlob(dataURI)
            //criar objeto para setImage
            var e = {target: { files: [file]}}
            this.setImage(e)     
            this.closeVideo()       
        },
        loadCamera () {
            //Captura elemento de vídeo
            document.getElementById('div_area').style.display = 'block' 
            var video = document.querySelector("#webCamera")
            //As opções abaixo são necessárias para o funcionamento correto no iOS
            video.setAttribute('autoplay', '')
            video.setAttribute('muted', '')
            video.setAttribute('playsinline', '')            
            //--
            //Verifica se o navegador pode capturar mídia
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'user'}})
                .then( function(stream) {
                    //Definir o elemento vídeo a carregar o capturado pela webcam
                    video.srcObject = stream
                })
                .catch(function(error) {
                    alert("Oooopps... Falhou :'(")
                })
            }
        },
        navigator () {
            if (navigator.appVersion.indexOf("Win") != -1) {
                this.nameNavigator = "Windows OS";
            } else {
                this.nameNavigator = "Outro OS";
            }
        },
        toggleOptions(){
            this.toggle = !this.toggle
        },
        uploadImage(image){
            this.firebaseHelper.uploadImage(this.chave, image, this.filename).then((url) => {
                this.cropedImage = url
                this.loading = false
                this.$emit('upload-foto', url)
                this.closeVideo()
            })
        },
        changeImg(){
            this.firebaseHelper.deleteImage(this.chave, this.filename).then(() => {
                this.cancelImage();
                this.$emit('upload-foto', "")
            }).catch((err) => {
                console.log(err)
            })
        },
        cancelImage(){
            this.srcImage = null
            this.cropedImage = null
        },
        cropAndUploadImage() {
            const { canvas } = this.$refs.cropper.getResult();
            this.loading = true
            canvas.toBlob(blob => {
                this.uploadImage(blob)
            }, 'image/jpeg');
        },
        setImage(e) {            
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
              const reader = new FileReader();
              reader.onload = (event) => {
                this.srcImage = event.target.result;
              };              
              reader.readAsDataURL(file);
            } else {
              alert('Sorry, FileReader API not supported');
            }
        },
	},
}
</script>

<style scoped>
    .btns-upload-files{
    display: flex;
    justify-content: space-between;
    transition: ease-in 0.8s;
}
.btns-upload-files button, .custom-btn-upload{
    width: 48%;
    border-radius: 12px !important;    
}
.custom-btn-upload{
    height: 40px;
    padding: 5px 10px;
    /* margin: 20px 0; */    
    min-width: initial;
    /* width: 44%; */
    border: none;
    border-radius: 8px !important;
    background: #0c7bc6;
    font-size: 14px;
    color: white;
    cursor: pointer;
    transition: transform 0.2s cubic-bezier(0.64, 0.09, 0.08, 1), box-shadow 0.2s cubic-bezier(0.64, 0.09, 0.08, 1);
    box-shadow:  0 3px 6px 0 rgba(0, 0, 0, 0.2);    
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.custom-btn-upload:hover{
    transform: translateY(-2px);
    box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.2);
}

.img-document{
    display: flex;
    flex-direction: column;
    max-width: 300px;
    height: auto;
    margin: 0 auto;
    padding: 10px;
    position: relative;        
}
.img-document img{
    max-width: 90%;
    /* max-height: 200px; */
    margin: auto;
}

@media screen and (min-width: 425px) {
    .img-document{
        max-width: 340px;
    }
}

@media screen and (min-width: 525px) {
    .img-document{
        max-width: 440px;
    }
}

@media screen and (min-width: 625px) {
    .img-document{
        max-width: 540px;
    }
}

.uploadedImage{
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.uploadedImage button{
    width: 70%;
    margin: 10px auto;
    padding: 8px;
    height: auto;
}

.left-btn{
    float: left;
    background-color: #C4C4C4;
}

.right-btn{
    float: right;
}

.div-father-btn-toggle-camera{
    margin: auto 0;
}

.div-btn-toggle-camera{
    position: absolute;
    top: 0;
    right: 0;
}

h6.title-cropper {
    height: 31px;
    display: flex;  
    align-items: center;
}

.div-btn-toggle-camera button{
    width: 40px;
    height: 40px;
    margin: 0;
    outline: none;
}

.icon-button-cropper {
    border-radius: 20px;
    background-color: #03a9f4;
    color: #ffff;
    font-size: 24px !important;
    padding: 5px !important;
    cursor: pointer;
}
.vue-advanced-cropper__cropper-wrapper {
    width: 85% !important;
    height: 85% !important;    
}
.vue-advanced-cropper__stretcher {
    max-width: 85% !important;
    margin: auto;
}
.vue-advanced-cropper__background {
    max-width: 85% !important;
    margin: auto;
}
.vue-advanced-cropper__foreground {
    max-width: 85% !important;
    margin: auto;
}

body{
	font-family: sans-serif;
	margin: 0;
}

/* css foto windows */
.area{
	margin: 10px auto;
	box-shadow: 0 10px 100px #ccc;
	/* padding: 20px; */
	box-sizing: border-box;
	max-width: 90%;
}

.area video{
	width: 100%;
	height: auto;
	background-color: whitesmoke;
}

.area textarea{
	width: 100%;
	margin-top: 10px;
	height: 80px;
	box-sizing: border-box;
}

.area button{
    min-width: -webkit-fill-available;
	-webkit-appearance: none;
	box-sizing: border-box;
	text-align: center;
	text-transform: uppercase;	
}

.area button:focus{
	outline: none;	
}
</style>